<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('A1188FR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['A1188FR']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-if="bool_showSearchBar && getUserInfo.AT < 3">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="true"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper py-0' v-if="convertToBool(iframe_url)"  style="height:75vh">
                <iframe @load="iframe_load" :src="iframe_url" frameborder="0" class="afb1188forecast-iframe w-100"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { loadingFullScreen } from '@/modules/Constant.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { constAccessType } from '@/modules/Constant.js';


    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                // search fields
                searchAgi: 0,
                searchAgent: null,
                iframe_url: null,
                iframe_baseurl: null,
                constAccessType: constAccessType,
                hideBrand: false,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.searchAgi = 0;
                if (value) {
                    var agentList = value.split("-");
                    this.searchAgi = agentList[agentList.length - 1];
                }
            },
            newsearch() {
                this.$refs.search.focus();
                this.renderIframe();
            },
            renderIframe() {
                if (!this.searchAgi && this.getUserInfo.AT != 3) {
                    this.showErrorMessage(null, this.getLanguage['MEM']['PSAA'], 1000);
                    return;
                }

                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;

                if (this.searchAgi > 0) {
                    agentGId = this.searchAgi;
                }

                var path = '';

                if (agentGId) {
                    path += "&AGI=" + agentGId;
                }

                if (path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/reports/afb1188forecast?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_fullLoading = true;
                            that.iframe_baseurl = d.D;
                        }
                        else {
                            that.iframe_baseurl = null;
                        }

                        that.updateIFrameUrl();
                    });
            },
            iframe_load() {
                this.bool_fullLoading = false;
            },
            updateIFrameUrl() {
                if (this.iframe_baseurl) {

                    this.iframe_url = this.iframe_baseurl + '&lang=' + this.get1188Language(this.getLangCode);
                }
                else {
                    this.iframe_url = null;
                }
            },
            get1188Language(langCode) {
                switch (langCode) {
                    case "id":
                        return "EN-AU"; // Indonesia
                    case "vn":
                        return "EN-IE"; // Vietnam
                    case "th":
                        return "TH-TH"; // Thai
                    case "cn":
                        return "ZH-CN"; // Chinese (Simplified)
                    case "kr":
                        return "EN-TT"; // Korean
                    case "en":
                    default:
                        return "EN-US"; // English
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleIndex']),
        },
        watch: {
            getLanguage() {
                this.updateIFrameUrl();
            }
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS2';
            this.$parent.showActiveMenu = 'R.A1188FR';

            this.hideBrand = this.getUserInfo.IHAGIF;
            if (this.getUserInfo.AT == 3) {
                this.renderIframe();
            }
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/AFB1188Forecast.vue